import React from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {
  Facebook,
  Instagram,
  Linkedin,
  X,
  Whatsapp,
  Telegram,
  Gift,
  Copy,
} from '../../../../media/images/shareModal'
import brandingConfig from '../../../../config/brandingConfig'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useThemeMode} from '../../../partials'

const ReferEarnModal = ({isActive, setIsActive, shareLink, url, props}: any) => {
  const {formatMessage} = useIntl()
  const link = url

  function handleSocialShare(platform: string) {
    let message = ''
    let url = '' // Define platform-specific share URLs
    switch (platform) {
      case 'facebook':
        url = brandingConfig.socialLinks.facebook
        break
      case 'instagram':
        url = brandingConfig.socialLinks.instagram
        break
      case 'twitter':
        url = brandingConfig.socialLinks.twitter
        break
      case 'linkedin':
        url = brandingConfig.socialLinks.linkedin
        break
      case 'whatsapp':
        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message + link)}`
        break
      case 'telegram':
        url = brandingConfig.socialLinks.telegram
        break
      default:
        return
    }
    window.open(url, '_blank')
  }

  const {mode} = useThemeMode()

  return (
    <>
      <Modal
        {...props}
        size='md'
        show={isActive}
        onHide={() => {
          setIsActive(false)
        }}
      >
        <div className='p-6'>
          {/* Close Modal Icon  */}
          <div className='w-100 d-flex flex-end' onClick={() => setIsActive(false)}>
            <KTSVG
              className='cursor-pointer'
              path={
                mode === 'dark'
                  ? toAbsoluteUrl('/media/icons/digital-signing/ic_close_dark.svg')
                  : toAbsoluteUrl('/media/icons/digital-signing/ic_close.svg')
              }
            />
          </div>

          {/* Modal Body  */}
          <div className='mb-8'>
            {/* Title refer modal  */}
            <div className='mb-8'>
              <h1 className='text-dark text-center lh-base'>
                {formatMessage({id: 'Give 10% off. Get 10% per referral'})}
              </h1>
              <h1 className='text-primary text-center lh-base'>
                {formatMessage({id: 'For Lifetime'})}
              </h1>
            </div>

            {/* Sub-Title refer modal  */}
            <p className='text-center'>
              {formatMessage({
                id: 'Invite others to experience RecordsKeeper.AI! Share your unique referral link and earn lifetime commission on every paid subscription made through your link.',
              })}
            </p>

            {/* Link Input refer modal  */}
            <div className='d-flex justify-content-between align-items-center border rounded border-primary p-3 mb-4'>
              <div className=' d-flex gap-2 align-items-center'>
                <img src={Gift} alt='gift' />
                <div>
                  <p className='mb-0 text-muted'>{formatMessage({id: 'Invite Link'})}</p>
                  <p className='mb-0 text-dark'>{formatMessage({id: `${shareLink}`})}</p>
                </div>
              </div>

              <img
                src={Copy}
                alt='copy'
                className='cursor-pointer'
                onClick={() => {
                  navigator.clipboard.writeText(`${url}`)
                  toast.success(formatMessage({id: 'Invite Link Copied'}))
                }}
              />
            </div>

            <button
              className='btn bg-primary w-100 mb-2 text-center text-white'
              onClick={() => {
                navigator.clipboard.writeText(`${url}`)
                toast.success(formatMessage({id: 'Invite Link Copied'}))
              }}
            >
              {formatMessage({id: 'Copy Invite Link'})}
            </button>

            <Link
              to='/setting/user-settings?tab=referrals'
              onClick={() => setIsActive(false)}
              className='btn btn-outline-primary w-100'
            >
              {formatMessage({id: 'Go To Referral Dashboard'})}
            </Link>
          </div>

          {/* Social Media Sharing  */}
          <p className='text-center mb-0'>
            {formatMessage({
              id: 'Start sharing with friends, clients, and professional networks — and enjoy recurring rewards as they subscribe.',
            })}
          </p>
          <div className='social-outer-container'>
            <button className='social-container' onClick={() => handleSocialShare('facebook')}>
              <img src={Facebook} alt='facebook-icon' />
            </button>
            <button className='social-container' onClick={() => handleSocialShare('instagram')}>
              <img src={Instagram} alt='instagram-icon' />
            </button>
            <button className='social-container' onClick={() => handleSocialShare('linkedin')}>
              <img src={Linkedin} alt='linkedin-icon' />
            </button>
            <button className='social-container' onClick={() => handleSocialShare('twitter')}>
              <img src={X} alt='twitter-icon' />
            </button>
            <button className='social-container' onClick={() => handleSocialShare('whatsapp')}>
              <img src={Whatsapp} alt='whatsapp-icon' />
            </button>
            <button className='social-container' onClick={() => handleSocialShare('telegram')}>
              <img src={Telegram} alt='telegram-icon' />
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ReferEarnModal
